import ParkPassAPI from "../parkpassAxiosConfig";

export const getAdminWalletTransactions = async (params = {}) => {
  try {
    const {
      page = 1,
      pageSize = 25,
      transactionType,
      status,
      userId,
      paymentMethod,
      search,
      date_from,
      date_to,
      no_pagination,
    } = params;

    const queryParams = {
      page,
      page_size: pageSize,
    };

    if (transactionType) queryParams.transaction_type = transactionType;
    if (status) queryParams.status = status;
    if (userId) queryParams.user_id = userId;
    if (paymentMethod) queryParams.payment_method = paymentMethod;
    if (search) queryParams.search = search;
    if (date_from) queryParams.date_from = date_from;
    if (date_to) queryParams.date_to = date_to;
    if (no_pagination) queryParams.no_pagination = true;

    const response = await ParkPassAPI.get("/v1/wallet/admin/transactions", {
      params: queryParams,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getUserNames = async () => {
  try {
    const response = await ParkPassAPI.get("/v1/users/users/names");
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getAdminConsumption = async (params = {}) => {
  try {
    const {
      page = 1,
      pageSize = 25,
      userId,
      search,
      matricule,
      non_zero,
      date_from,
      date_to,
      no_pagination,
    } = params;

    const queryParams = {
      page,
      page_size: pageSize,
    };

    if (userId) queryParams.user_id = userId;
    if (search) queryParams.search = search;
    if (matricule) queryParams.matricule = matricule;
    if (non_zero) queryParams.non_zero = true;
    if (date_from) queryParams.date_from = date_from;
    if (date_to) queryParams.date_to = date_to;
    if (no_pagination) queryParams.no_pagination = true;

    const response = await ParkPassAPI.get("/v1/wallet/admin/consumption", {
      params: queryParams,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};
